export const PAYMENT_OPTION_IDS = {
  CREDIT_CARD: 1,
  REQUEST: 2
};

export const PAYMENT_OPTIONS = [
  { id: PAYMENT_OPTION_IDS.CREDIT_CARD, name: 'Buy with credit card' },
  { id: PAYMENT_OPTION_IDS.REQUEST, name: 'Send request' }
];
